import { Tooltip, TooltipProps } from 'antd';
import { IconSvg } from 'shared/icon';
import { InfoIconWrapper, StyledFlexLabel } from 'app/auth/components/Login.styled';
import { ReactNode } from 'react';
import { StyledLabelText } from 'shared/icon/Icon.styled';
import { StyledHintText, StyledLabelInfoAndHint } from './Info.styled';

interface LabelInfoProps {
  label: string;
  info?: ReactNode;
  hint?: string;
  trigger?: TooltipProps['trigger'];
  width?: number;
  height?: number;
}

const LabelInfo = ({
  label, info, hint, trigger = 'hover', width = 14, height = 14,
}: LabelInfoProps) => (
  <StyledLabelInfoAndHint>
    <StyledFlexLabel>
      <StyledLabelText>{label}</StyledLabelText>
      {info && (
        <Tooltip title={info} trigger={trigger}>
          <InfoIconWrapper>
            <IconSvg icon="InfoIcon" width={width} height={height} />
          </InfoIconWrapper>
        </Tooltip>
      )}
    </StyledFlexLabel>
    {hint && <StyledHintText>{hint}</StyledHintText>}
  </StyledLabelInfoAndHint>
);

export default LabelInfo;
